<template>
  <div>
    <div v-if="!loading" class="max-w-6xl mx-auto text-gray-600">
      <section>
        <div
          class="flex flex-col justify-center px-5 py-20 lg:flex-row"
          v-for="m in community"
          :key="m.id"
        >
          <div class="flex-grow mb-10 lg:mb-0">
            <h3 class="mb-4 text-4xl font-bold sm:text-5xl text-primary-orange">
              {{ m.Title }}
            </h3>
            <div class="text-lg leading-relaxed">
              <p>
                <VueShowdown :markdown="m.Content" />
              </p>
            </div>
          </div>
          <img
            alt="team"
            :src="getBaseUrl() + m.Image.url"
            class="flex-shrink-0 object-cover object-center mb-4 rounded-sm lg:pl-8 lg:w-1/2"
          />
        </div>
      </section>
      <div class="px-5">
        <hr />
      </div>
      <section>
        <div
          class="flex flex-col justify-center px-5 py-20 lg:flex-row"
          v-for="h in hospital"
          :key="h.id"
        >
          <img
            alt="team"
            :src="getBaseUrl() + h.Image.url"
            class="flex-shrink-0 order-2 object-cover object-center mb-4 rounded-sm lg:w-1/2 lg:order-1"
          />
          <div class="flex-grow order-1 mb-10 lg:pl-8 lg:order-2">
            <h3
              class="mb-4 text-4xl font-bold title-font sm:text-5xl text-primary-orange"
            >
              {{ h.Title }}
            </h3>
            <div class="text-lg leading-relaxed">
              <p>
                <VueShowdown :markdown="h.Content" />
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else>
      <img :src="loadingImage" class="w-64 m-auto" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { baseUrl } from "../Api";
import { mapGetters } from "vuex";
export default {
  name: "OurCommunity",
  data() {
    return {
      items: [],
      community: [],
      hospital: [],
      loadingImage: require("../assets/curve-Loading.gif"),
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      lang: "LanguageStore/lang",
      apiD: "LanguageStore/apiCommunity",
      apiH: "LanguageStore/apiHospitals",
    }),
  },
  watch: {
    async lang() {
      this.loading = true;
      await this.getData();
    },
  },
  methods: {
    scrollToTop() {
      this.open = !this.open;
      window.scrollTo(0, 0);
    },
    getBaseUrl() {
      return baseUrl;
    },
    async getData() {
      try {
        const community = await axios.get(this.apiD);
        this.community = community.data;
        this.loading = false;
        const hospitals = await axios.get(this.apiH);
        this.hospital = hospitals.data;
        this.loading = false;
      } catch (error) {
        this.error = error;
      }
    },
  },
  async created() {
    await this.getData();
  },
};
</script>

<style scoped>
hr {
  background: linear-gradient(217deg, #d76738, rgba(255, 0, 0, 0) 70.71%),
    linear-gradient(127deg, #4aa350, rgba(0, 255, 0, 0) 70.71%);
  transition: width 0.35s;
  height: 1px;
  border-top-width: 0 !important;
}
</style>
